import moment from "moment";
import { useCallback } from "react";
import { FaCalendarAlt, FaHamburger } from "react-icons/fa";
import { Outlet, useOutletsSearch } from "../../../data/outlets.api";
import { SearchSource } from "../MapSearch";

export const useOutletsSource = (query: string): SearchSource<Outlet> => ({
  title: "Outlets",
  source: useOutletsSearch(query),
  transformer: useCallback(
    (e) => ({
      icon: FaHamburger,
      iconColour: "orange.400",
      title: e.name,
      subtitle: e.isOpen ? "Open" : "Closed",
      to: `/outlets/${e.businessID}`,
    }),
    []
  ),
  priority: 0,
});
